export enum ModalVariantE {
  ERROR_MODAL = 'ERROR_MODAL',
}
